import { useNavigate, useParams } from "react-router-dom";
import UsageDashboard from "@/components/usage/UsageDashboard";

export default function ApiKeyUsagePage() {
  const { keyId } = useParams();
  const navigate = useNavigate();
  return (
    <UsageDashboard
      basePath={`/tenant/api-keys/${keyId}`}
      variant="tenant"
      keyId={keyId}
      onBack={() => navigate("/app/admin/api-keys")}
    />
  );
}
